import { supabase } from '../lib/supabase';

export async function clearAllOrders() {
  try {
    console.log('Clearing all orders...');
    
    // Delete all orders
    const { error: ordersError } = await supabase
      .from('orders')
      .delete()
      .neq('id', '00000000-0000-0000-0000-000000000000'); // Delete all records
    
    if (ordersError) {
      console.error('Error deleting orders:', ordersError);
      return { success: false, error: ordersError };
    }

    // Delete all subscriptions
    const { error: subscriptionsError } = await supabase
      .from('subscriptions')
      .delete()
      .neq('id', '00000000-0000-0000-0000-000000000000'); // Delete all records
    
    if (subscriptionsError) {
      console.error('Error deleting subscriptions:', subscriptionsError);
      return { success: false, error: subscriptionsError };
    }

    // Delete all waitlist entries
    const { error: waitlistError } = await supabase
      .from('waitlist')
      .delete()
      .neq('id', '00000000-0000-0000-0000-000000000000'); // Delete all records
    
    if (waitlistError) {
      console.error('Error deleting waitlist:', waitlistError);
      return { success: false, error: waitlistError };
    }

    console.log('All orders, subscriptions, and waitlist entries cleared successfully!');
    return { success: true };
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, error };
  }
}

// Function to run from browser console
(window as any).clearAllOrders = clearAllOrders;